<template>
<div>
  <v-row>
      <v-col cols="1"></v-col>
      <v-col cols="10">
          <v-autocomplete v-model="key" :items="keys" clearable :loading="loading" :search-input.sync="search" hide-no-data no-filter @click:clear="keys = []" item-text="oem" :item-value="item => item" @input="input" label="OEM/FCC/IC/iSKU" solo return-object>
              <v-list-tile name="ava1" class="pa-2" slot="item" slot-scope="{item}">
                  <v-avatar left>
                      <v-img v-bind:src="item.image"></v-img>
                  </v-avatar>
                  {{item.oem}} - {{item.fcc}} - {{item.ic}}
              </v-list-tile>
          </v-autocomplete>
      </v-col>
      <v-col cols="1"></v-col>
  </v-row>
  <v-row v-if="key != null">
      <v-col cols="1"></v-col>
      <v-col cols="9">
        <v-card>
            <v-card-title style="height:50px;margin-top:-3% !important;">
                Receive Inventory:
                <div style="margin-left:10px">
                    <v-chip outlined color="primary">{{key.oem}}</v-chip> -
                    <v-chip outlined color="primary">{{key.fcc}}</v-chip> -
                    <v-chip outlined color="primary">{{key.ic}}</v-chip>
                </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-form ref="data" lazy-validation></v-form>
            <v-row v-for="(loc,index) in locations" style="height:65px">
              <v-col cols="1"></v-col>
              <v-col cols="4">
                <v-text-field v-model="values[index]" @change="inputChange(index)" :rules="[rules.required]" required dense type="number" :label="loc.name" placeholder="0" outlined></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-chip  color="primary">{{getLocationStock(loc.id)}} in Stock</v-chip>
              </v-col>
            </v-row>
            <v-row align="center" style="height:60px">
              <v-col cols="1"></v-col>
              <v-col cols="4">
                <v-text-field v-model="request.cost" dense outlined label="Cost:"></v-text-field>
              </v-col>
              <v-col class="text-info" style="margin-bottom:4%">
                  will be overwritten for previous cost.
              </v-col>
            </v-row>

            <v-row align="center" style="height:60px">
              <v-col cols="1"></v-col>
              <v-col cols="4">
                <v-text-field v-model="request.price" dense outlined label="Price:"></v-text-field>
              </v-col>
              <v-col class="text-info" style="margin-bottom:4%">
                  will be overwritten for previous price.
              </v-col>
            </v-row>
            <v-row style="height:60px">
              <v-col cols="1"></v-col>
              <v-col cols="8">
                <v-text-field v-model="request.notes" dense type="text" label="Notes:" required outlined></v-text-field>
              </v-col>
            </v-row>

            <v-row style>
                <v-col cols="5"></v-col>
                <v-col cols="2">
                    <v-btn color="success" @click="recieveItem" >
                        Submit
                    </v-btn>
                </v-col>
                <v-col cols="1"></v-col>
            </v-row>

            </v-card>
      </v-col>
      <v-col cols="1"></v-col>
    </v-row>
</div>
</template>
<script>
export default {
  created() {
    this.locations = this.$store.state.token.locations;
    this.$api.getSuppliers().then((res) => {
      if (res.status == 200) {
        this.suppliers = res.data;
      }
    });
  },
  data: () => ({
    suppliers: [],
    locations: [],
    keys: [],
    key: null,
    item: null,
    values: [],
    search:'',
    rules: {
        required: value => !!value || 'Required.'
    },
    loading:false,
    request: {
      locations: [],
      oem: '',
      price: '',
      cost: '',
      notes: ''
    },
  }),
  watch: {
      search(val) {
          if (this.loading) return;
          if (val == '' || val == null) return;
          this.loading = true;
          this.$api.searchKey(val).then((response) => {
              if (response.status == 200)
                  this.keys = response.data;
              this.loading = false;
          }).then(error => {
              this.loading = false;
          })
      }
  },
  methods: {
    input(val) {
      if (val != null) {
        this.request.oem = this.key.oem;
        this.$api.searchItem(this.request).then((response) => {
          if (response.status = 200) {
            this.item = response.data;
            this.request.cost = this.item.cost;
            this.request.price = this.item.price;
          }
        }).catch(error => {

        })
      }
    },
    inputChange(index) {
      let location = this.locations[index];
      let x = -1;
      for (let i = 0; i < this.request.locations.length; i++) {
        if (this.request.locations[i].location.id == location.id) {
          x = i;
          break;
        }
      }
      if (x == -1) {
        this.request.locations.push({
          'location': location,
          'amount': this.values[index]
        });
      } else {
        this.request.locations[x].amount = this.values[index];
      }


    },
    getLocationStock(id) {
      if (this.item != null) {
        let x = -1;
        for (let i = 0; i < this.item.locations.length; i++)
          if (this.item.locations[i].location.id == id) {
            x = i;
            break;
          }

        if (x == -1)
          return "0";
        else
          return this.item.locations[x].amount;
      }

    },
    recieveItem() {
      if(this.$refs.data.validate()){
      this.$overlay.show(this);
      this.$api.recieveItem(this.request).then((res) => {
        if (res.status == 200){
          this.request = {
            locations: [],
            oem: '',
            price: '',
            cost: '',
            notes: '',
            supplier: null
          };
          this.item = null;
          this.keys = [];
          this.values = [];
          this.key = null;
          this.$toasted.success("Inventory updated").goAway(1200);
          this.$refs.data.reset();
        }
        this.$overlay.hide();
      }).catch(error => {
        this.$toasted.error("Error updating inventory").goAway(1200);
        this.$overlay.hide();
      })
      }
    },
    shouldShowInventoryRelated(){
      return this.$store.state.isManager || this.$store.state.isAdmin;
    }
  }
}
</script>
